export default {
	data: () => ({
        G_CAPTCHA_SITE_KEY: '6LfXwWEUAAAAAHU_v_WOnTHRbIr15iNdaGbk__pG',
        REG_ALPHABATE_ONLY : '^[A-Za-z ]{2,}$',
        REG_EMAIL_PATTERN : /^[A-Za-z0-9]([\-\._]?[A-Za-z0-9]){0,}@[A-Za-z0-9-]+\.([A-Za-z]{1,7}\.)?[A-Za-z]{2,6}$/,
        // REG_EMAIL_PATTERN : '^[A-Za-z0-9]([\-\._@]?[A-Za-z0-9]){0,}@[A-Za-z0-9]+\.([A-Za-z]{1,6}\.)?[A-Za-z]{2,6}$',
        REG_MOBILE_PATTERN : '^[1-9][0-9]{9}$',
        REG_INTERNATIONAL_MOBILE_PATTERN : '^[1-9][0-9]{6,12}$',
        REG_COUNTRY_CODE_PATTERN : '^[1-9][0-9]{9}$',
        REG_INTERNATIONAL_COUNTRY_CODE_PATTERN : '^[1-9][0-9]{6,12}$',
    }),
    methods: {
        validateCharacters(value){
            if (value.length > 0) {
                let validNamePattern = new RegExp(this.REG_ALPHABATE_ONLY);
                return validNamePattern.test(value);
            }
            else
                return false;
        },
        validateEmail(value){
            if (value.length > 0) {
                let validEmailPattern = new RegExp(this.REG_EMAIL_PATTERN);
                return validEmailPattern.test(value);
            }
            else
                return false;
        },
        validateMobileNumber(value){
            if (value.length > 0) {
                let validMobileNumberPattern = new RegExp(this.REG_MOBILE_PATTERN);
                return validMobileNumberPattern.test(value);
            }
            else 
                return false;
        },
        validateInternationalMobileNumber(value){
            if (value.length > 0) {
                let validIntMobileNumberPattern = new RegExp(this.REG_INTERNATIONAL_MOBILE_PATTERN);
                return validIntMobileNumberPattern.test(value);
            }
            else 
                return false;
        }
    }
}
